import React from 'react';

import { FsProps } from './FsProps';
import { FieldSelectApprove } from './fs-approve';

const FieldSelectIsΑpproved = ({
  label = 'Εγκεκριμένο',
  name = 'isApproved',
  disable = false,
  ...rest
}: FsProps & { readonly disable?: boolean }) => {
  return (
    <FieldSelectApprove label={label} name={name} disable={disable} {...rest} />
  );
};
export default FieldSelectIsΑpproved;

